<template>
    <div v-if="player" class="bng-narrow-container bng-profile bng-profile-container">
        <div class="bng-profile-login">
            <button class="button is-link bng-profile-close" @click="goBack"></button>
            {{ player.username }}
        </div>
        <balance></balance>
        <div v-if="isPaymentSystemDepositAvailable || isPinDepositAvailable" class="bng-profile-item" id="deposit">
            <div class="bng-profile-item-title deposit">{{ 'payment system.deposit' | translate }}</div>
            <div class="bng-profile-item-inner">
                <balance-operation typeOperation="deposit"></balance-operation>
            </div>
        </div>
        <div v-if="isPaymentSystemWithdrawalAvailable || isPinWithdrawalAvailable" class="bng-profile-item" id="withdrawal">
            <div class="bng-profile-item-title withdrawal">{{ 'payment system.withdrawal' | translate }}</div>
            <div class="bng-profile-item-inner">
                <balance-operation typeOperation="withdrawal"></balance-operation>
            </div>
        </div>
        <div class="bng-profile-item" v-if="isWithdrawalPins" id="pincodes">
            <div class="bng-profile-item-title withdrawal">{{ 'components.pages.withdrawal-codes.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                <withdrawal-codes></withdrawal-codes>
            </div>
        </div>
        <div class="bng-profile-item" id="transactions">
            <div class="bng-profile-item-title transactions">{{ 'components.pages.history.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                {{ 'components.pages.history.view' | translate }}
                <router-link to="/history/all">{{ 'components.pages.history.all link' | translate }}</router-link>
            </div>
        </div>
        <div class="bng-profile-item" v-if="isMessages" id="messages">
            <div class="bng-profile-item-title messages">{{ 'components.pages.messages.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                <messages></messages>
            </div>
        </div>
        <div class="bng-profile-item" id="settings">
            <div class="bng-profile-item-title settings">{{ 'components.pages.profile.settings.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                <profile-settings></profile-settings>
            </div>
        </div>
        <div class="bng-profile-item" v-if="passwordChangingAllowed" id="password">
            <div class="bng-profile-item-title password">{{ 'components.pages.profile.password.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                <profile-password></profile-password>
            </div>
        </div>
        <div class="bng-profile-logout-block" id="logout">
            <a class="button button-logout" @click="openLogout()">
                <span class="icon">
                    <i class="fas fa-sign-out-alt"></i>
                </span>
                <span>{{ 'components.common.topbar.logout' | translate }}</span>
            </a>
        </div>
        <div class="bng-profile-item" v-if="lockPlayerBlockShown">
            <div class="bng-profile-item-title password">{{ 'components.pages.profile.exclusion.title' | translate }}</div>
            <div class="bng-profile-item-inner">
                <profile-exclusion></profile-exclusion>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Balance from '../balance/balance.vue';
import BalanceOperation from '../balance-operation/balance-operation.vue';
import Messages from '../messages/messages.vue';
import WithdrawalCodes from '../withdrawal-codes/withdrawal-codes.vue';
import ProfileSettings from './settings.vue';
import ProfilePassword from './password.vue';
import ProfileExclusion from './exclusion.vue';

import pushService from '../../../../../../_common/services/push.service';
import pinService from '../../../../../../_common/services/pin.service';

export default {
    name: 'profile',
    components: {
        Balance,
        BalanceOperation,
        Messages,
        WithdrawalCodes,
        ProfileSettings,
        ProfilePassword,
        ProfileExclusion
    },
    data() {
        return {
            passwordChangingAllowed: false,
            lockPlayerBlockShown: false,
            isMessages: false,
            isWithdrawalPins: false,
            backRoute: null
        };
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        client: function() {
            return Vue.state.client.get();
        },
        balance() {
            return this.player && this.player.balance;
        },
        balanceReal() {
            return this.balance && this.balance.real;
        },
        isPinDepositAvailable() {
            return this.client.paymentSystem.pinDepositAllowed;
        },
        isPinWithdrawalAvailable() {
            return this.client.paymentSystem.pinWithdrawalAllowed;
        },
        isPaymentSystemDepositAvailable() {
            return this.client.paymentSystem.paymentSystemDepositAllowed;
        },
        isPaymentSystemWithdrawalAvailable() {
            return this.client.paymentSystem.paymentSystemWithdrawalAllowed;
        }
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.passwordChangingAllowed = client.view.profile.passwordChangingAllowed;
        this.lockPlayerBlockShown = client.view.profile && client.view.profile.lockPlayerBlockShown;
        // get first messages
        const messages = await pushService.get(1, 0);
        this.isMessages = messages && messages.length;

        const pins = await pinService.getNotAppliedWithdrawPins();
        this.isWithdrawalPins = pins && pins.length;
    },
    mounted() {
        this.backRoute = Vue.state.route.from.get() || '/';
    },
    watch: {
        balanceReal() {
            (async () => {
                const pins = await pinService.getNotAppliedWithdrawPins();
                this.isWithdrawalPins = pins && pins.length;
            })();
        }
    },
    methods: {
        openLogout() {
            Vue.state.modals.openLogoutModal().then(
                async () => {
                    await Vue.router.teleport.home();
                },
                () => {}
            );
        },
        goBack() {
            const backPath = this.backRoute || '/';
            this.$router.push(backPath);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/profile/profile.vue